import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import Link from "next/link";
import Image from "next/image";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
interface WaveLeaderboardDropAuthorProps {
  readonly drop: ExtendedDrop;
}
export const WaveLeaderboardDropAuthor: React.FC<WaveLeaderboardDropAuthorProps> = t0 => {
  const $ = _c(29);
  const {
    drop
  } = t0;
  const t1 = `/${drop.author.handle}`;
  let t2;
  if ($[0] !== drop.author.pfp) {
    t2 = <div className="tw-h-11 tw-w-11 tw-bg-iron-900 tw-relative tw-flex-shrink-0 tw-rounded-lg">{drop.author.pfp ? <div className="tw-rounded-lg tw-h-full tw-w-full"><div className="tw-h-full tw-w-full tw-max-w-full tw-rounded-lg tw-overflow-hidden tw-bg-iron-900 tw-ring-1 tw-ring-white/10"><div className="tw-h-full tw-text-center tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-overflow-hidden"><Image src={resolveIpfsUrlSync(drop.author.pfp)} alt="Profile picture" width={44} height={44} className="tw-rounded-lg tw-object-contain" /></div></div></div> : <div className="tw-h-full tw-w-full tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-white/10 tw-rounded-lg" />}</div>;
    $[0] = drop.author.pfp;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Link href={t1} onClick={_temp} className="tw-flex tw-items-center tw-gap-x-2 tw-no-underline group">{t2}</Link>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = drop.author.handle ?? drop.author.id;
  const t5 = `/${drop.author.handle}`;
  let t6;
  if ($[5] !== drop.author.handle) {
    t6 = <span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author.handle}</span>;
    $[5] = drop.author.handle;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <Link href={t5} onClick={_temp2} className="tw-no-underline">{t6}</Link>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t7) {
    t8 = <UserProfileTooltipWrapper user={t4}>{t7}</UserProfileTooltipWrapper>;
    $[10] = t4;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== drop.author.level) {
    t9 = <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[13] = drop.author.level;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = drop.winning_context?.decision_time || null;
  let t11;
  if ($[15] !== drop.rank || $[16] !== t10) {
    t11 = <WinnerDropBadge rank={drop.rank} decisionTime={t10} />;
    $[15] = drop.rank;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="tw-size-[3px] tw-bg-iron-900 tw-rounded-full tw-flex-shrink-0" />;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== drop.created_at) {
    t13 = <WaveDropTime timestamp={drop.created_at} />;
    $[19] = drop.created_at;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t13 || $[23] !== t8 || $[24] !== t9) {
    t14 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-flex-wrap">{t8}{t9}{t11}{t12}{t13}</div>;
    $[21] = t11;
    $[22] = t13;
    $[23] = t8;
    $[24] = t9;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14 || $[27] !== t3) {
    t15 = <div className="tw-flex tw-items-center tw-gap-x-3">{t3}{t14}</div>;
    $[26] = t14;
    $[27] = t3;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
};
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}